module.exports = __webpack_public_path__ + "img/SWP_Staff_2H_02 (2).9cb3f92c.png";